import React from 'react'
import { Step } from './Step';
import styles from './Stepper.module.scss';

interface Props {  
  activeStep: number,
  onChangeOrder?: (index: number) => void,
  stepLabels: string[]
}

export const Stepper = ({ stepLabels, onChangeOrder, activeStep }: Props) => { 
  return (
    <div className={styles.stepper}>
      {stepLabels.map((label: string, index: number) => (                
        <Step
          key={index}
          order={index + 1}
          label={label}
          isActivated={index === activeStep}
          onClickStep={onChangeOrder? () => onChangeOrder(index + 1) : onChangeOrder}
        />
      ))}
    </div>
  )
}

export default Stepper